import React from 'react';
import styles from '../../styles/components/TestimonialItem.module.scss';
import classnames from 'classnames';

export default function TestimonialItem({data}) {
    const name = data.name || '';
    const position = data.position || '';
    const quote = data.quote || '';
    const imgSrc = data.imgSrc || '';
    const imgAlt = data.imgAlt || '';

    return (
        <div className={classnames(styles.testimonialItemWrapper, styles[data.style])}>
            <div className={styles.imgContainerWrapper}>
                <img className={styles.image} src={imgSrc} alt={imgAlt}/>
            </div>
            <div className={styles.textContainerWrapper}>
                <div className={classnames(styles.textContainer, styles.unselectable)}>
                    <div className={styles.topLine}>
                        <div className={styles.name}>{name}</div>
                        <div className={styles.position} dangerouslySetInnerHTML={{ __html: position }} />
                    </div>
                    <div className={styles.quote} dangerouslySetInnerHTML={{ __html: quote }} />
                </div>
            </div>
            <div className={styles.topLineMobile}>
                <div className={styles.nameMobile}>{name}</div>
                <div className={styles.positionMobile} dangerouslySetInnerHTML={{ __html: position }} />
            </div>
            <div className={styles.quoteMobile} dangerouslySetInnerHTML={{ __html: quote }} />
        </div>
    );
}